import axios from 'axios'

let log = process.env.NODE_ENV === 'production'
log = true

const restApi = axios.create({
    baseURL:  process.env.NODE_ENV === 'production'?
                'https://mobile.growerp.com/rest/':
                'http://localhost:8080/rest/',
    headers:
        {   // 'Content-Type': 'application/json;charset=UTF-8',
            //"Access-Control-Allow-Origin": "*",
            //'Access-Control-Allow-Credentials': true,
            //'Access-Control-Allow-Headers': 'X-PINGOTHER, Origin, X-Requested-With, Content-Type, Accept',
            'api_key': ''
        },
    withCredentials: true,
    timeout: 5000,
})

export default class BackendService {
    getStoreContentInfo(productStoreId, language) {
        return restApi.get('s1/growerp/storecontents/'+productStoreId+'/info', {
            params: {
                locale: language
            }
        })
    }
    getContentHTML(productStoreId, wikiSpaceId, pagePath) {
        return restApi.get('s1/growerp/storecontents/aws/PublishedWikiPageText', {
            params: {
                productStoreId: productStoreId,
                contentWikiSpaceId: wikiSpaceId,
                pagePath: pagePath
            }
        })
    }
    getBlogContent(productStoreId, wikiSpaceId, pagePath) {
        return restApi.get('s1/growerp/storecontents/'+productStoreId+'/BlogPost', {
            params: {
                productStoreId: productStoreId,
                contentWikiSpaceId: wikiSpaceId,
                pagePath: pagePath
            }
        })
    }
    getBlogInfo(productStoreId, wikiSpaceId) {
        return restApi.get('s1/growerp/storecontents/'+productStoreId+'/BlogInfo', {
            params: {
                productStoreId: productStoreId,
                contentWikiSpaceId: wikiSpaceId
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/backend-services.js